import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStateList,
  setStateId,
} from "../../../slices/LocationSlice/stateSlice";
import {
  fetchMapData,
  updateMapData,
} from "../../../slices/LocationSlice/mapSlice";
import EditableTable from "./Table";
import Pagination from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import SearchTable from "../../../components/SearchTable";
import api from "@/auth/api";
import AreaModal from "./AreaModal";

function Map({editable}) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.state);
  const map = useSelector((state) => state.map);
  const stateId = useSelector((state) => state.state.stateId);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logData, setLogData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [pincodeList, setPicodeList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [areaDis, setAreaDis] = useState(false);

  const currentItems = Array.isArray(map?.mapData?.result)
    ? map.mapData.result.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];
    
  const totalPages = Math.ceil(
    (map?.mapData?.result?.length || 0) / itemsPerPage
  );

  const headers =
    map?.mapData?.result?.length > 0
      ? Object.keys(map.mapData.result[0]).filter((key) => key !== "id")
      : [];

  const editableFields = [
    "title",
    "val",
    "status",
    "State",
    "Region",
    "Division",
    "District",
    "Block",
    "Pincode",
    "Area",
  ]; // Adjust based on your actual data

  const getAllData = async () => {
    try {
      const resp = await api.get("/location/panel/Location");
      console.log(resp);
      let allDataResp = resp?.data?.result;
      //   setAllData(allDataResp);
      setStateList(allDataResp.STATE);
      setRegionList(allDataResp.REGION);
      setDistrictList(allDataResp.DISTRICT);
      setDivisionList(allDataResp.DIVIsion);
      setBlockList(allDataResp.BLOCK);
      setPicodeList(allDataResp.PINCODE);
      setAreaList(allDataResp.AREA);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  useEffect(() => {
    if (state.status === "idle") dispatch(fetchStateList());
  }, [dispatch, state.status]);

  useEffect(() => {
    if (state.stateList?.result?.length) {
      const id = stateId || state.stateList.result[0].id;
      dispatch(setStateId(id));
      dispatch(fetchMapData(id));
    }
  }, [dispatch, state.stateList, stateId]);

  const handleStateChange = (e) => {
    const id = e.target.value;
    dispatch(setStateId(id));
    dispatch(fetchMapData(id));
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const row = map.mapData.result.find((r) => r.id === rowId);
    setEditedData(row);
  };

  const handleAreaUpdate = (id) => {
    setAreaDis(true);
  };

  const handleSave = async () => {
    console.log(editedData);
    const areaId = areaList.filter((f) => f.title === editedData.Area)[0]?.id;
    const blockId = blockList.filter((f) => f.title === editedData.Block)[0]
      ?.id;
    const districtId = districtList.filter(
      (f) => f.title === editedData.District
    )[0]?.id;
    const divisionId = divisionList.filter(
      (f) => f.title === editedData.Division
    )[0]?.id;
    const pincodeId = pincodeList.filter(
      (f) => f.title === editedData.Pincode
    )[0]?.id;
    const regionId = regionList.filter((f) => f.title === editedData.Region)[0]
      ?.id;
    const currStateId = stateList.filter((f) => f.title === editedData.State)[0]
      ?.id;
    const finalData = {
      id: editedData.id,
      Area: areaId,
      Block: blockId,
      District: districtId,
      Division: divisionId,
      Pinode: pincodeId,
      Region: regionId,
      State: currStateId,
      status: editedData.status,
      val: editedData.val,
    };
    console.log(finalData);
    const resp = await dispatch(updateMapData(finalData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchMapData(stateId));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (["status"].includes(field)) {
      setEditedData((prev) => ({ ...prev, [field]: !val }));
    } else {
      setEditedData((prev) => ({ ...prev, [field]: e.target.value }));
    }
  };

  const handleLog = (id) => {
    const log = map.mapData?.Change_Log?.find((l) => l.id === id)?.oldTrack;
    setLogData(log || []);
    setLogModalOpen(true);
  };

  return (
    <div className="w-full flex items-center flex-col">
      <div className="w-11/12 items-center justify-between flex mb-2 mt-1">
        <div className="flex items-center">
          <div>Map Data for</div>
          <select
            className="ml-2 p-0.5 px-2"
            value={stateId}
            onChange={handleStateChange}
          >
            {state.stateList?.result?.map((s) => (
              <option key={s.id} value={s.id}>
                {s.title}
              </option>
            ))}
          </select>
        </div>

        <SearchTable
          placeholder="Search map entries..."
          data={currentItems}
          allData={map.mapData?.result}
          onSearchResults={setFilteredRows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>

      {map.status === "loading" || stateList.length === 0 ? (
        <Loader />
      ) : (
        <EditableTable
          headers={headers}
          rows={currentItems}
          editRowId={editRowId}
          editedData={editedData}
          handleEdit={handleEdit}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleChange={handleChange}
          handleLog={handleLog}
          editableFields={editableFields}
          status={map.status}
          filteredRows={filteredRows}
          //   allData={allData}
          stateList={stateList}
          regionList={regionList}
          divisionList={divisionList}
          districtList={districtList}
          blockList={blockList}
          pincodeList={pincodeList}
          areaList={areaList}
          handleAreaUpdate={handleAreaUpdate}
          editable={editable}
        />
      )}

      <div className="flex mt-4 items-center justify-between w-11/12">
        {searchQuery.length < 3 && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        )}
      </div>

      <Modal
        isOpen={logModalOpen}
        onClose={() => setLogModalOpen(false)}
        title="Change Log"
        content={<ChangeLog data={logData} />}
      />

      <Modal
        isOpen={areaDis}
        onClose={() => setAreaDis(false)}
        title="Update Area"
        content={<AreaModal rowId={editedData.id} areaList={areaList} />}
      />

    </div>
  );
}

export default Map;
